let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cbFPj")).then(() => parcelRequire('6ETqg'));